module.exports = __webpack_public_path__ + "img/Logo-Paket-Global.db1522cd.png";